// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.privacy-page{
    padding-top: 180px;
    background-color: var(--bg-white);
  }
  
  .privacy-page-content h1
  {
      font-size: var(--font-size-xxxlarge);
      font-weight: var(--font-bold);
      color: var(--text-primary);
      margin-bottom: 0px;
      font-family: var(--font-codec-cold);
      line-height: 1.3;
      text-align: center;
  }
  
  .legal-text p{
      font-size: var(--font-size-xsmall);
      font-weight: var(--font-medium);
      color: var(--text-gray-dark);
  }
  
  .legal-text .legal-bold{
      font-weight: var(--font-bold);
  }
  
  .legal-text h3{
      font-size: var(--font-size-large);
      font-weight: var(--font-bold);
      color: var(--text-black); 
      margin-bottom: 13px; 
  }
  
  .legal-text ul li{
      font-size: var(--font-size-xsmall);
      font-weight: var(--font-medium);
      color: var(--text-gray-dark);
      line-height: 1.8;
  }
  
  .legal-text h6{
      font-size: var(--font-size-xsmall);
      font-weight: var(--font-bold);
      color: var(--text-gray-dark);
  }
  
  .privacy-page-content-2
  {
      padding-bottom: 100px;
  }

  .page-header-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-bottom: 15px;
  }
  
  .back-btn-container {
      position: absolute;
      left: 15px;
  }
  
  @media (max-width: 767px) {
      .page-header-container {
          flex-direction: column;
          align-items: flex-start;
      }
      .back-btn-container {
          position: static;
          margin-bottom: 15px;
      }
      .privacy-page-content h1 {
          text-align: center;
          width: 100%;
          margin-bottom: 10px;
      }
  }`, "",{"version":3,"sources":["webpack://./src/components/Website/TermsPage/TermsPage.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;;MAEI,oCAAoC;MACpC,6BAA6B;MAC7B,0BAA0B;MAC1B,kBAAkB;MAClB,mCAAmC;MACnC,gBAAgB;MAChB,kBAAkB;EACtB;;EAEA;MACI,kCAAkC;MAClC,+BAA+B;MAC/B,4BAA4B;EAChC;;EAEA;MACI,6BAA6B;EACjC;;EAEA;MACI,iCAAiC;MACjC,6BAA6B;MAC7B,wBAAwB;MACxB,mBAAmB;EACvB;;EAEA;MACI,kCAAkC;MAClC,+BAA+B;MAC/B,4BAA4B;MAC5B,gBAAgB;EACpB;;EAEA;MACI,kCAAkC;MAClC,6BAA6B;MAC7B,4BAA4B;EAChC;;EAEA;;MAEI,qBAAqB;EACzB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA;MACI,kBAAkB;MAClB,UAAU;EACd;;EAEA;MACI;UACI,sBAAsB;UACtB,uBAAuB;MAC3B;MACA;UACI,gBAAgB;UAChB,mBAAmB;MACvB;MACA;UACI,kBAAkB;UAClB,WAAW;UACX,mBAAmB;MACvB;EACJ","sourcesContent":["\n.privacy-page{\n    padding-top: 180px;\n    background-color: var(--bg-white);\n  }\n  \n  .privacy-page-content h1\n  {\n      font-size: var(--font-size-xxxlarge);\n      font-weight: var(--font-bold);\n      color: var(--text-primary);\n      margin-bottom: 0px;\n      font-family: var(--font-codec-cold);\n      line-height: 1.3;\n      text-align: center;\n  }\n  \n  .legal-text p{\n      font-size: var(--font-size-xsmall);\n      font-weight: var(--font-medium);\n      color: var(--text-gray-dark);\n  }\n  \n  .legal-text .legal-bold{\n      font-weight: var(--font-bold);\n  }\n  \n  .legal-text h3{\n      font-size: var(--font-size-large);\n      font-weight: var(--font-bold);\n      color: var(--text-black); \n      margin-bottom: 13px; \n  }\n  \n  .legal-text ul li{\n      font-size: var(--font-size-xsmall);\n      font-weight: var(--font-medium);\n      color: var(--text-gray-dark);\n      line-height: 1.8;\n  }\n  \n  .legal-text h6{\n      font-size: var(--font-size-xsmall);\n      font-weight: var(--font-bold);\n      color: var(--text-gray-dark);\n  }\n  \n  .privacy-page-content-2\n  {\n      padding-bottom: 100px;\n  }\n\n  .page-header-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      margin-bottom: 15px;\n  }\n  \n  .back-btn-container {\n      position: absolute;\n      left: 15px;\n  }\n  \n  @media (max-width: 767px) {\n      .page-header-container {\n          flex-direction: column;\n          align-items: flex-start;\n      }\n      .back-btn-container {\n          position: static;\n          margin-bottom: 15px;\n      }\n      .privacy-page-content h1 {\n          text-align: center;\n          width: 100%;\n          margin-bottom: 10px;\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
